import React from "react";
import TowerMasterList from './towermasterlist.jsx';
import TowerMissionData from './towermissiondata.jsx';

class Towers extends React.Component {

    render() {
           return (
                <div>
                    <TowerMasterList/>
                    <TowerMissionData/>
                </div>
            )
        }
}


export default Towers;